export default {"src":"/_next/static/media/linkedin-white-bg.c52657f9.svg","height":24,"width":24};